import React, { useEffect, useRef, useState } from 'react';

// A countdown bar with an honest tick-down to zero, then a fired state.
// Default copy is "NEXT ROUND IN" / "STARTING NOW" but `label`/`firedLabel`
// let callers reuse it for other deadlines (e.g. "FINAL STANDINGS IN").
const NextRoundBar = ({
  ms = 10000,
  label = 'NEXT ROUND IN',
  firedLabel = 'STARTING NOW',
  onComplete,
}) => {
  const [remaining, setRemaining] = useState(ms);
  const startedAt = useRef(Date.now());
  const onCompleteRef = useRef(onComplete);
  onCompleteRef.current = onComplete;

  useEffect(() => {
    startedAt.current = Date.now();
    setRemaining(ms);
    const id = setInterval(() => {
      const elapsed = Date.now() - startedAt.current;
      const left = Math.max(0, ms - elapsed);
      setRemaining(left);
      if (left <= 0) {
        clearInterval(id);
        if (onCompleteRef.current) onCompleteRef.current();
      }
    }, 100);
    return () => clearInterval(id);
  }, [ms]);

  const seconds = Math.ceil(remaining / 1000);
  const pct = Math.max(0, Math.min(100, (remaining / ms) * 100));
  const fired = remaining <= 0;

  return (
    <div style={{
      width: '100%',
      background: fired ? 'var(--c-green)' : 'var(--c-yellow)',
      color: 'var(--c-ink)',
      border: 'var(--border-ink)',
      borderRadius: 'var(--radius-btn)',
      boxShadow: 'var(--shadow-hard)',
      padding: '12px 14px',
      display: 'flex', alignItems: 'center', gap: 10,
      position: 'relative', overflow: 'hidden',
    }}>
      {/* progress sliver — sits behind everything, drains right to left */}
      <div style={{
        position: 'absolute', inset: 0,
        background: 'var(--c-ink)',
        opacity: 0.12,
        transformOrigin: 'left',
        transform: `scaleX(${pct / 100})`,
        transition: 'transform 100ms linear',
        pointerEvents: 'none',
      }} />

      <div style={{
        position: 'relative',
        fontFamily: 'var(--font-display)', fontSize: 13, letterSpacing: 0.5,
        flex: 1,
      }}>
        {fired ? firedLabel : label}
      </div>

      {!fired && (
        <div style={{
          position: 'relative',
          fontFamily: 'var(--font-display)', fontSize: 28, lineHeight: 1,
          background: 'var(--c-ink)', color: 'var(--c-yellow)',
          padding: '6px 12px', borderRadius: 8,
          minWidth: 44, textAlign: 'center',
          animation: 'penPulsePin 1.2s ease-in-out infinite',
        }}>{seconds}</div>
      )}
      {fired && (
        <div style={{
          position: 'relative',
          fontFamily: 'var(--font-display)', fontSize: 18, lineHeight: 1,
          color: 'var(--c-ink)',
        }}>★</div>
      )}
    </div>
  );
};

export default NextRoundBar;
